import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Table from '../../components/Table'
import { Metrics } from '../../Themes'
import { findPropertiesById } from '../../sources/SearchSource'
import { translate } from 'react-i18next'
import { sortArray } from '../../Utils'
import { tableKeysDefault } from '../../Utils/Defaults'

const Container = styled.div`
  height: calc(100vh - ${Metrics.components.navbarDefault});
`

class FavoriteList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      width: window.screen.availWidth,
      height:
        document.getElementById('propertyList') &&
        document.getElementById('propertyList').offsetHeight,
      properties: props.user.preferredProperties || [],
      tableHeaderKeys: R.clone(tableKeysDefault)
    }
    this.updateDimensions = this.updateDimensions.bind(this)
    this.sortElements = this.sortElements.bind(this)
  }

  componentWillMount () {
    const ids = this.state.properties.map(el => {
      return el.id
    })
    findPropertiesById(ids)
      .then(response => {
        this.setState({ properties: response.data })
      })
      .catch(error => {
        console.log(error)
      })
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    this.setState({
      width: window.screen.availWidth,
      height:
        document.getElementById('propertyList') &&
        document.getElementById('propertyList').offsetHeight
    })
    this.forceUpdate()
  }

  sortElements (el) {
    const keys = R.clone(this.state.tableHeaderKeys)
    const keyIndex = R.findIndex(R.propEq('title', el.title), keys)
    const result = sortArray(el, this.state.properties)
    keys.forEach(el => {
      el.sort = null
    })
    keys[keyIndex] = result.sortKey
    this.setState({ properties: result.list, tableHeaderKeys: keys })
  }

  render () {
    const { propertyDetails } = this.props
    return (
      <Container id={'propertyList'}>
        <Table
          keys={this.state.tableHeaderKeys}
          data={this.state.properties}
          rowClick={propertyDetails}
          width={this.state.width}
          height={this.state.height}
          handleSort={this.sortElements}
        />
      </Container>
    )
  }
}

FavoriteList.propTypes = {
  user: PropTypes.object,
  propertyDetails: PropTypes.func,
  router: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'favorite' ], { wait: true })(FavoriteList)



// WEBPACK FOOTER //
// ./src/pages/Favorite/FavoriteList.js